export default "__VITE_ASSET__66b6121e__"